export const PARTNER_MODULE_NAME = 'partner';
